interface WeeklyGmvChartLegendProps {
  trajectoryLabel: string
  realizedLabel: string
  forecastLabel: string
  missingTrajectoryLabel: string
  hasTrajectory: boolean
}

const WeeklyGmvChartLegend = ({
  trajectoryLabel,
  realizedLabel,
  forecastLabel,
  missingTrajectoryLabel,
  hasTrajectory
}: WeeklyGmvChartLegendProps) => (
  <div className="mg-weekly-gmv-chart-legend vp-caption">
    <div className="mg-weekly-gmv-chart-legend-item">
      <span className="mg-weekly-gmv-chart-legend-trajectory" />
      <span className={hasTrajectory ? undefined : 'mg-weekly-gmv-chart-legend-missing-trajectory'}>
        {hasTrajectory ? trajectoryLabel : missingTrajectoryLabel}
      </span>
    </div>
    <div className="mg-weekly-gmv-chart-legend-item">
      <span className="mg-weekly-gmv-chart-legend-realized">
        <span />
      </span>
      <span>{realizedLabel}</span>
    </div>
    <div className="mg-weekly-gmv-chart-legend-item">
      <span className="mg-weekly-gmv-chart-legend-forecast">
        <span />
      </span>
      <span>{forecastLabel}</span>
    </div>
  </div>
)

export default WeeklyGmvChartLegend
